export default __webpack_public_path__ + "static/media/news-small-homepage-4.8e7fa899.png";